export const REFERRAL_REQUEST = 'REFERRAL_REQUEST'
export const REFERRAL_SUCCESS = 'REFERRAL_SUCCESS'
export const REFERRAL_FAIL = 'REFERRAL_FAIL'

export const REFERRAL_EDIT_REQUEST = 'REFERRAL_EDIT_REQUEST'
export const REFERRAL_EDIT_SUCCESS = 'REFERRAL_EDIT_SUCCESS'
export const REFERRAL_EDIT_FAIL = 'REFERRAL_EDIT_FAIL'